



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import env from '@/env';
import SaveButton from '@/components/App/SaveButton.vue';

@Component({
  components: { SaveButton }
})
export default class SwapResponsibleDialog extends Vue {
  @Prop()
  cutoverplanId?: number;

  private dialog = false;

  private oldResponsibleId = 0;

  private newResponsibleId = 0;

  private scope = {
    steps: true,
    cutoverplan: true
  };

  async swapResponsibles() {
    const response = axios.post(`${env.backend_url}/responsible/swap/`, {
      cutoverplan_id: this.cutoverplanId,
      responsible_id: this.oldResponsibleId,
      replace_with_id: this.newResponsibleId,
      scope: this.scope
    });

    if ((await response).status === 200) {
      this.$emit('done');
    }
    return response;
  }
}
